module.exports = __webpack_public_path__ + "media/images/icons/outlined/safety-294db4b45dfa7eb2dfdfebd7c2b587e8.svg";